
  import { Component, Prop, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    @Inject() information:any
    get msg(){
      let msg = this.information.find(v=>{
        return v.key == this.modekey
      })
      // console.log(msg,'6623')
      return msg
    }
    
  } 
